import BreadCrumb from '../../../../Components/Common/BreadCrumb';
import React, { useEffect, useState } from 'react';
import {Container, Row} from 'reactstrap';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import overview from "../../../../assets/images/blog/overview.jpg"
import avatar2 from "../../../../assets/images/users/avatar-2.jpg"
import avatar6 from "../../../../assets/images/users/avatar-6.jpg"
import avatar8 from "../../../../assets/images/users/avatar-8.jpg"
import avatar10 from "../../../../assets/images/users/avatar-10.jpg"
import small4 from "../../../../assets/images/small/img-4.jpg"
import small5 from "../../../../assets/images/small/img-5.jpg"
import SimpleBar from 'simplebar-react';
import Sidepanel from "../ListView/Sidepanel";
import MainGuide from "./MainGuide";
import ApiService from "../../util/ApiService";


const UserGuideOverview = () => {

    document.title = "Descrição Guia | Plantão Rápido";

    const { url } = useParams(); // <-- Captura o parâmetro da rota
    const [loading, setLoading] = useState(false);
    const [guide, setGuide] = useState(null);



    useEffect(() => {
        if (url) fetch();
    }, [url]);

    const fetch = async () => {
        try {
            setLoading(true);
            const response = await ApiService.send('get', `${process.env.REACT_APP_URL_API}guide-user/one-record/${url}`,
                {}, true
            );

            const {data} = ApiService.handleApiResponse(response);
            setGuide(data);

        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoading(false);
        }
    };



    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title="Guia do Usuário" pageTitle="Ajuda" />
                    <Row>
                            <MainGuide loading={loading} guide={guide}/>
                        <Sidepanel />

                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default UserGuideOverview